define(function(require) {
    // GEO09E03_CS_STA layer definition config
    return {
        LAYER_ID : "GEO09E03_CS_STA_GEN",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "CARTOVISTA",
        USE_TYPED_ARRAY : true,
        INDEX : 1,
        FIELDS : [
            {ID : "CD_CS_STA", NAME : "Code", DATA_TYPE : "STRING"},
            {ID : "NOM_OFFCL_CS_STA", NAME : "Nom", DATA_TYPE : "STRING"},
            {ID : "NOM_SITE_WEB_GDUNO", NAME : "Site web", DATA_TYPE : "STRING"}
        ],
        STYLES : [
            {
                ID : "Centre de services scolaire et commission scolaire à statut particulier",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "NONE",
                        STROKE_COLOR : "rgba(224,138,0,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 4
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(224,138,0,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Centre de services scolaire et commission scolaire à statut particulier",
            FEATURE_ID_DATACOLUMN : "CD_CS_STA",
            FEATURE_NAME_DATACOLUMN : "NOM_OFFCL_CS_STA",
            DATATIP_DATACOLUMNS : ["CD_CS_STA", "NOM_OFFCL_CS_STA"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_CS_STA", "NOM_OFFCL_CS_STA", "NOM_SITE_WEB_GDUNO"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_CS_STA", "NOM_OFFCL_CS_STA", "NOM_SITE_WEB_GDUNO"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_CS_STA", "NOM_OFFCL_CS_STA"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "NOM_OFFCL_CS_STA",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false
        },
        ZOOM_LAYERING : {
            BASE_LAYER_ID : "GEO09E03_CS_STA",
            QUERY_EXPRESSION : {
                LOGICAL_OPERATOR : null,
                QUERIES : [{FIELD : "CD_CS_STA", OPERATOR : "=", VALUE : undefined}]
            },
            SWITCH_SCALE : 100000
        }
    };
});
